import qs from 'qs'
import config from 'config'
import {BRANDS, LANDING_PAGE_LANGUAGES} from 'const'
import {getWebview} from 'utils/stringUtils'

import onelog from './brands/onelog'
import blick from './brands/blick'
import energy from './brands/energy'
import beobachter from './brands/beobachter'
import wirtschaftsmedien from './brands/wirtschaftsmedien'
import schweizerillustrierte from './brands/schweizerillustrierte'
import moonandstars from './brands/moonandstars'
import vintage from './brands/vintage'
import schlager from './brands/schlager'
import interview from './brands/interview'
import rockit from './brands/rockit'
import twentymin from './brands/twentymin'
import lessentiel from './brands/lessentiel'
import testing from './brands/testing'
import pme from './brands/pme'
import illustre from './brands/illustre'
import lematin from './brands/lematin'
import srg from './brands/srg'

import baz from './brands/baz'
import berneroberlander from './brands/berneroberlander'
import bernerzeitung from './brands/bernerzeitung'
import bilan from './brands/bilan'
import derbund from './brands/derbund'
import derlandbote from './brands/derlandbote'
import finanzundwirtschaft from './brands/finanzundwirtschaft'
import langenthalertagblatt from './brands/langenthalertagblatt'
import lematindimanche from './brands/lematindimanche'
import schweizerfamilie from './brands/schweizerfamilie'
import sihltaler from './brands/sihltaler'
import sonntagszeitung from './brands/sonntagszeitung'
import tagesanzeiger from './brands/tagesanzeiger'
import tamedia from './brands/tamedia'
import thalwileranzeiger from './brands/thalwileranzeiger'
import thunertagblatt from './brands/thunertagblatt'
import tribunedegeneve from './brands/tribunedegeneve'
import twentyfourhours from './brands/twentyfourhours'
import zurcherunterlander from './brands/zurcherunterlander'
import zurichseezeitung from './brands/zurichseezeitung'
import cash from './brands/cash'
import jobs from './brands/jobs'
import jobup from './brands/jobup'
import jobscout24 from './brands/jobscout24'
import redsport from './brands/redsport'
import caminada from './brands/caminada'
import glueckspost from './brands/glueckspost'
import programmzeitschriften from './brands/programmzeitschriften'
import landliebe from './brands/landliebe'
import zff from './brands/zff'
import aargauerzeitung from './brands/aargauerzeitung'
import ticketcorner from './brands/ticketcorner'
import jobbern from './brands/jobbern'
import autodesjahres from './brands/autodesjahres'
import nzz from './brands/nzz'
import watson from './brands/watson'

const BLICK_MOBILE_CLIENT_IDS = [
  'ldM1dUQlB5WYdy7CjACR8CU3l6FgJugn',
  'mIjX6CA152HvYKmKNGvvxffbq2OzfRxp',
  'GuDzFnvdGnh1gAaB4lcXX42J0YxsaLHL',
]

export const CLIENT_THEME = {
  [BRANDS.blick]: blick,
  [BRANDS.energy]: energy,
  [BRANDS.beobachter]: beobachter,
  [BRANDS.wirtschaftsmedien]: wirtschaftsmedien,
  [BRANDS.schweizerillustrierte]: schweizerillustrierte,
  [BRANDS.moonandstars]: moonandstars,
  [BRANDS.vintage]: vintage,
  [BRANDS.schlager]: schlager,
  [BRANDS.rockit]: rockit,
  [BRANDS.twentymin]: twentymin,
  [BRANDS.lessentiel]: lessentiel,
  [BRANDS.testing]: testing,
  [BRANDS.pme]: pme,
  [BRANDS.illustre]: illustre,
  [BRANDS.lematin]: lematin,
  [BRANDS.onelog]: onelog,
  [BRANDS.srg]: srg,
  [BRANDS.cash]: cash,
  [BRANDS.interview]: interview,
  [BRANDS.redsport]: redsport,
  [BRANDS.caminada]: caminada,
  [BRANDS.glueckspost]: glueckspost,
  [BRANDS.programmzeitschriften]: programmzeitschriften,
  [BRANDS.landliebe]: landliebe,

  [BRANDS.baz]: baz,
  [BRANDS.berneroberlander]: berneroberlander,
  [BRANDS.bernerzeitung]: bernerzeitung,
  [BRANDS.bilan]: bilan,
  [BRANDS.derbund]: derbund,
  [BRANDS.derlandbote]: derlandbote,
  [BRANDS.finanzundwirtschaft]: finanzundwirtschaft,
  [BRANDS.langenthalertagblatt]: langenthalertagblatt,
  [BRANDS.lematindimanche]: lematindimanche,
  [BRANDS.schweizerfamilie]: schweizerfamilie,
  [BRANDS.sihltaler]: sihltaler,
  [BRANDS.sonntagszeitung]: sonntagszeitung,
  [BRANDS.tagesanzeiger]: tagesanzeiger,
  [BRANDS.tamedia]: tamedia,
  [BRANDS.thalwileranzeiger]: thalwileranzeiger,
  [BRANDS.thunertagblatt]: thunertagblatt,
  [BRANDS.tribunedegeneve]: tribunedegeneve,
  [BRANDS.twentyfourhours]: twentyfourhours,
  [BRANDS.zurcherunterlander]: zurcherunterlander,
  [BRANDS.zurichseezeitung]: zurichseezeitung,
  [BRANDS.jobs]: jobs,
  [BRANDS.jobup]: jobup,
  [BRANDS.jobscout24]: jobscout24,
  [BRANDS.zff]: zff,
  [BRANDS.aargauerzeitung]: aargauerzeitung,
  [BRANDS.ticketcorner]: ticketcorner,
  [BRANDS.jobbern]: jobbern,
  [BRANDS.autodesjahres]: autodesjahres,
  [BRANDS.nzz]: nzz,
  [BRANDS.watson]: watson,
}

const TX_GROUP_CLIENT_MAP = {
  // 20min
  // dev
  '7H7IGMgD0E5qhXNpOJKD6Vzn1l0AQv9o': BRANDS.twentymin, // web
  // stage
  // YwmA3uKi8x7YAe3ttesGum95vD1DB8LY: BRANDS.twentymin, // web
  '0b6dc07134a4b6306b574bea64b0cd9d': BRANDS.twentymin, // web
  // prod
  // OtYl4MH20En41QB5dYjcI5v9mzLv0FVh: BRANDS.twentymin, // web
  '2e3e2e31a9f1d31a22d2a302dbbdfcd4': BRANDS.twentymin, // web

  // Lematin
  // dev
  '5acee1cbfcf930e1b959745c4af5cf33': BRANDS.lematin, // web
  // stage
  // '43a66cc5a75120dcdbe8d76a2ff4e69b': BRANDS.lematin, // web
  '2ac728284bcc908c340016ae40522ce4': BRANDS.lematin, // web
  // prod
  // '1231bed416732d6139a20057dcc4569d': BRANDS.lematin, // web
  '368077a19b6b377e6e1fadf1c5e5ca3c': BRANDS.lematin, // web

  // Basler Zeitung
  // dev
  f4a2f5439aba465b1605ec5f687f8ad9: BRANDS.baz, // web
  // stage
  // bdc9c55e5703187a2fd70f0f03de9d6f: BRANDS.baz, // web
  '566d1b9e6ee92f58982da16adb43cd48': BRANDS.baz, // web
  bf329d0cbd439c1316d40d6a3467695b: BRANDS.baz, // invitation
  // prod
  '0afe65bedea7e106513eabe15c2fbb95': BRANDS.baz, // web
  aac9d202dfb5a2a59ee3d83780736fe5: BRANDS.baz, // web
  '0d7fba86048829d3498b92a1549f6784': BRANDS.baz, // web

  // 24hours
  // dev
  '41018b8a2972fbe3ffa8096aeb4ec131': BRANDS.twentyfourhours, // web
  // stage
  // d2732c773e7790e4096f27883ca605f9: BRANDS.twentyfourhours, // web
  '4296319a268257dab44d5a136a562420': BRANDS.twentyfourhours, // web
  '9c18392353bcbeae635cb6f43c4ac6d7': BRANDS.twentyfourhours, // invitation
  // prod
  // '27291f6fbd24b4f2efde09ead1eaaabd': BRANDS.twentyfourhours, // web
  '01219ad7ba1c7fd3e408ad43911ea708': BRANDS.twentyfourhours, // web
  '0c4a3401029b8b6b40ae6ebccd758473': BRANDS.twentyfourhours, // invitation

  // Tages Anzeiger
  // dev
  '819f0e7374bd0dd0796a4b2b8f28db9a': BRANDS.tagesanzeiger, // web
  // stage
  // '938b2cf5d3cf5aaa2b25786ad04248fd': BRANDS.tagesanzeiger, // web
  c4bb5fe759cf8dfbc1ff9ae38331a574: BRANDS.tagesanzeiger, // web
  '1e627ef03e9cf05beaaa73f3771e4cdb': BRANDS.tagesanzeiger, // invitation
  // prod
  // '323ebaeb98c4632899dbe609bb5675b5': BRANDS.tagesanzeiger, // web
  '4e4700cc743745e47ad3d5da361691e5': BRANDS.tagesanzeiger, // web
  '3b28b8d79055ed94a41a35ace04cf340': BRANDS.tagesanzeiger, // invitation

  // Berner Oberländer
  // dev
  cef9ff09231a4932992ab990876c2709: BRANDS.berneroberlander, // web
  // stage
  // '011ba75b8cc64c5a846c47065b0fa999': BRANDS.berneroberlander, // web
  f533589e59d44e531857dec5eb27b5a0: BRANDS.berneroberlander, // web
  de9f33c897b34bfe1d90bc17d8b91972: BRANDS.berneroberlander, // invitation
  // prod
  // e631310d5aec4315bb599e850bfc7557: BRANDS.berneroberlander, // web
  b638408c70dd47d2b35f0ba008295358: BRANDS.berneroberlander, // web
  '06374ff81ca2c9f2a05e910065814907': BRANDS.berneroberlander, // invitation

  // BZ Berner Zeitung
  // dev
  '52d7640f9f374621a87a4e2d0b216d28': BRANDS.bernerzeitung, // web
  // stage
  // '2ca18129fcdd4db0a7720f876954bfa2': BRANDS.bernerzeitung, // web
  cc33f5f51e68795da40937255924b392: BRANDS.bernerzeitung, // web
  '829b24666d29db553a4a39af44bf1cab': BRANDS.bernerzeitung, // invitation
  // prod
  // e9fa390d486c49648aef7f3b9d426805: BRANDS.bernerzeitung, // web
  '9e95031d012266759d6f7337f22d38ce': BRANDS.bernerzeitung, // web
  '4a0692dd5e7fd68f22afaa79d6c01828': BRANDS.bernerzeitung, // invitation

  // Bilan
  // dev
  '56b7d54f480644bc9eb22fccb8b5b09d': BRANDS.bilan, // web
  // stage
  // '98db9fb846c54631b9735bd710f1c448': BRANDS.bilan, // web
  b42849054a4f1402e7c1c92095de78ce: BRANDS.bilan, // web
  af4bb78a539dd7ecf4e98d8052037997: BRANDS.bilan, // invitation
  // prod
  // '30dc2b69e18c4c35bc616f63c35defab': BRANDS.bilan, // web
  '6dca3be2116f3a39ada918e58b277fc7': BRANDS.bilan, // web
  '68244de202f6b605181d2f34003790a7': BRANDS.bilan, // invitation

  // Der Bund
  // dev
  '8cc827d7279f4752b843b9ff0169db53': BRANDS.derbund, // web
  // stage
  // '41cfef4567944071a3c5124813f8afba': BRANDS.derbund, // web
  f28e745d1e19ea794dbc83ea51ec9741: BRANDS.derbund, // web
  f6bef01e53740811022ce55b5edba688: BRANDS.derbund, // invitation
  // prod
  // '53650b07630c4fcdbc35e568821c89ba': BRANDS.derbund, // web
  '670d6a9b1dec3ae90ef5322c63e5b637': BRANDS.derbund, // web
  '2757fb5db3309a184cf903a8c505c251': BRANDS.derbund, // invitation

  // Der Landbote
  // dev
  abeef5e9298c4517a83190b5882faf28: BRANDS.derlandbote, // web
  // stage
  // '4177af1e60a341e791881f22d233591c': BRANDS.derlandbote, // web
  f8c5bda6e3f36da7b21bf2594dcefb5f: BRANDS.derlandbote, // web
  '4861073867f00df1979211d6fa54e739': BRANDS.derlandbote, // invitation
  // prod
  '98076f4f32ed4aafaf397951a83db652': BRANDS.derlandbote, // web
  aa79d7627ab918759aa89ccab49cd9ac: BRANDS.derlandbote, // web
  dc7225f444c5db201f043a180c5fc37e: BRANDS.derlandbote, // invitation

  // Finanz und Wirtschaft
  // dev
  fc004ae8791e4519a5ceef7d6fabd3b7: BRANDS.finanzundwirtschaft, // web
  // stage
  b1d6be20750d4a23b4ad46888e2be5ed: BRANDS.finanzundwirtschaft, // web
  '68602dad3994ace187baf68c5ec76e5e': BRANDS.finanzundwirtschaft, // web
  '22d56bd74e155c753a9d7a9838e014ff': BRANDS.finanzundwirtschaft, // invitation
  // prod
  // '6fdd2d6a6a004057b31b6c65ddcec938': BRANDS.finanzundwirtschaft, // web
  '0ef8694c1c58f9f72a3eef068ce98993': BRANDS.finanzundwirtschaft, // web
  '9bb60be4ca4db44a8b36254711d0fbd0': BRANDS.finanzundwirtschaft, // invitation

  // BZ Langenthaler Tagblatt
  // dev
  a1ca52e5b2e614462b4dcb57b2fcc044: BRANDS.langenthalertagblatt, // web
  // stage
  // '4d3d18d1254cad2e1417d8ce4992db28': BRANDS.langenthalertagblatt, // web
  '0c96dd0df7d429c6d2a66571db89a0ad': BRANDS.langenthalertagblatt, // web
  '4e9b60bbde5b5a98741f393832de6670': BRANDS.langenthalertagblatt, // invitation
  // prod
  // '45937c8b1d76d66eff9213cc916f9dc4': BRANDS.langenthalertagblatt, // web
  '584ebef250093c992df983e178d1792b': BRANDS.langenthalertagblatt, // web
  '1ae12f0121a0c8f2d783ca54ab25b34c': BRANDS.langenthalertagblatt, // invitation

  // Le Matin Dimanche
  // dev
  bcb9fd18378a4c68806d4dd02f6a7647: BRANDS.lematindimanche, // web
  // stage
  // f3dba82226a340988ca4eefdc8fb64f8: BRANDS.lematindimanche, // web
  '4a2eb502d490fdf9db8453330529af02': BRANDS.lematindimanche, // web
  '0ef51645e228d5cdb827faef5452cb4f': BRANDS.lematindimanche, // invitation
  // prod
  // '0f495fd633ae4f5f8d82ad8a49a9fe77': BRANDS.lematindimanche, // web
  '3c7d1f360d9c99cc8ef6d7e5ed7dccac': BRANDS.lematindimanche, // web
  '31c4d9400e846c970e4e1eab2b17a37b': BRANDS.lematindimanche, // invitation

  // Schweizer Familie
  // dev
  fec756513e75460080996fe3b961fa41: BRANDS.schweizerfamilie, // web
  // stage
  // bfaceec0dc3a49e0992127b5c7f197f0: BRANDS.schweizerfamilie, // web
  e5d8931c3dd39b6f6976131eefecf50e: BRANDS.schweizerfamilie, // web
  fa0117b5b4e69ef2a0d3cf734aaf4d09: BRANDS.schweizerfamilie, // invitation
  // prod
  // ae84a46098354d13a86d2236a4d1fab7: BRANDS.schweizerfamilie, // web
  '295b30ded23c3ec0dde6a1b478e3e709': BRANDS.schweizerfamilie, // web
  fc463157577a1323654d6e29d2931647: BRANDS.schweizerfamilie, // invitation

  // Sihltaler
  // dev
  be79cf5093c74c378594d23490121eb8: BRANDS.sihltaler, // web
  // stage
  // ca82ead3c7f344c3a0539e3609a1aba6: BRANDS.sihltaler, // web
  '747c2efa0ebcae5d8504ae457f8ac5ce': BRANDS.sihltaler, // web
  e2905cebd07658aced15883f63ebc469: BRANDS.sihltaler, // invitation
  // prod
  '2f73890327204e3e86540a557de20283': BRANDS.sihltaler, // web
  eefb2c027c609ab0dd8a46061c55adb7: BRANDS.sihltaler, // web
  '8684814555e9e21a14d03d379edbc12b': BRANDS.sihltaler, // invitation

  // SonntagsZeitung
  // dev
  '5f9b3ef0178a426da750082c0dbe911c': BRANDS.sonntagszeitung, // web
  // stage
  // ad80fc0b94674222bbd607ce914f828a: BRANDS.sonntagszeitung, // web
  b65c17d2dae254567c8f12883b397988: BRANDS.sonntagszeitung, // web
  e2627d63fa3e7d7819f67a57de83a62d: BRANDS.sonntagszeitung, // invitation
  // prod
  // dea248e85a9e4018a5112160517ea06f: BRANDS.sonntagszeitung, // web
  fca436b42e67102222611b1cdd75f184: BRANDS.sonntagszeitung, // web
  '9a371c4197c763043d16e343b825de4d': BRANDS.sonntagszeitung, // invitation

  // Tamedia
  // dev
  e38f68cd83dc4a3c9c0811b394950920: BRANDS.tamedia, // web
  // stage
  // d68b3bcc96ba4798b6a36d558718dd98: BRANDS.tamedia, // web
  f6f28120bb592f82905a3d1ead88292e: BRANDS.tamedia, // web
  '6d89656da3a137af8a100aec5a1959d1': BRANDS.tamedia, // invitation
  // prod
  // cc0aafbaecbf41f2b8031aed4c18aa6e: BRANDS.tamedia, // web
  '15d5d9c4e0037735605dcbedb4fd5ab9': BRANDS.tamedia, // web
  d0c0870df7f32aa97b321e7531c80e78: BRANDS.tamedia, // invitation

  // Thalwiler Anzeiger
  // dev
  c1ef9e5aa90346388502be9e6cb0e1a3: BRANDS.thalwileranzeiger, // web
  // stage
  // a9e5b95a9cab4bb1a9311b49f445dabb: BRANDS.thalwileranzeiger, // web
  '24eeb4b68057eede1b8154bd773862e7': BRANDS.thalwileranzeiger, // web
  caacee5ea33d6ded8054e9cba43c4e77: BRANDS.thalwileranzeiger, // invitation
  // prod
  // '82187be2068f412b9c94246bc3ed20e3': BRANDS.thalwileranzeiger, // web
  '30377368848e98ca13d3b0a6c779e0e7': BRANDS.thalwileranzeiger, // web
  '165f8e93cdf9bebe553943ef7d8fc9c8': BRANDS.thalwileranzeiger, // invitation

  // Thuner Tagblatt
  // dev
  cdce93c26feb4e0b988551345862fe35: BRANDS.thunertagblatt, // web
  // stage
  // '15fad9398e474df09bf0ea97bc91e02b': BRANDS.thunertagblatt, // web
  '1852ff00552617f2e0c00b062c060da7': BRANDS.thunertagblatt, // web
  dfed1320c323fc8c786094e1f36dc356: BRANDS.thunertagblatt, // invitation
  // prod
  // df445698471c45cb988b908761c51eb7: BRANDS.thunertagblatt, // web
  d259b82f9a312a0cbaa924bbf4bcd78d: BRANDS.thunertagblatt, // web

  // Tribune de Genève
  // dev
  bcfac6d8ec4946c6b113c7d91c9733aa: BRANDS.tribunedegeneve, // web
  // stage
  // bae5fb2b3be9418996fc0d865e2bdf54: BRANDS.tribunedegeneve, // web
  '444b2d2a2c4b1229201b7ae9bc93a21e': BRANDS.tribunedegeneve, // web
  '550ef1057fe9ae3d17f9a9344683de7a': BRANDS.tribunedegeneve, // invitation
  // prod
  // '9e47037491474eea8a1d0147eb2a6bb8': BRANDS.tribunedegeneve, // web
  '311c587a20a6efcd18d15192ab9d41fc': BRANDS.tribunedegeneve, // web
  '69d3c6a688701e05930c90a4d2fb73af': BRANDS.tribunedegeneve, // invitation

  // Zürcher Unterländer
  // dev
  eaac5b30d6fd41a5a8877dbeae376662: BRANDS.zurcherunterlander, // web
  // stage
  // '0b323e9807234541bc28087acc1bb6b3': BRANDS.zurcherunterlander, // web
  b4de2dc88d3db4a8fa51f22781e3818c: BRANDS.zurcherunterlander, // web
  c9fab14f91482d77923fdd4db144eaf0: BRANDS.zurcherunterlander, // invitation
  // prod
  // '5e20548491554fb2a04ce120b0282e23': BRANDS.zurcherunterlander, // web
  '69e4ad5c9501986586473d87e5966b1d': BRANDS.zurcherunterlander, // web
  '24437af9a5a2e9b81f834462cf63a1d2': BRANDS.zurcherunterlander, // invitation

  // Zürichsee-Zeitung
  // dev
  '68d00bd0e47f466bbde15437d45b50f3': BRANDS.zurichseezeitung, // web
  // stage
  // '9ede1cfd396641ca92cd4763cb0131e0': BRANDS.zurichseezeitung, // web
  b2d356cd3ee154a359f09b20ab060dcd: BRANDS.zurichseezeitung, // web
  d5637808a1643ed7f7351be3ab223429: BRANDS.zurichseezeitung, // invitation
  // prod
  // d2c0c062fb1840f8a86d29b52e7a481b: BRANDS.zurichseezeitung, // web
  dfac4f67bb2895ff69623f1e8145060f: BRANDS.zurichseezeitung, // web
  '6495726ef7a57d45407385450746718e': BRANDS.zurichseezeitung, // web
}

const ONELOG_CLIENT_MAP = {
  // dev
  Ta4QZ31uhtCHQ2ds06nu0EoWLgoMSSSS: BRANDS.blick,
  // stage
  CQJ8zOkS3GPvEB3b8j0C7hvfiJjwK6c3: BRANDS.blick,
  // prod
  I8Xm2IbKom1vgZaEeqbj3ID5CGWLQHsT: BRANDS.blick,

  // Blick Mobile
  // dev
  ldM1dUQlB5WYdy7CjACR8CU3l6FgJugn: BRANDS.blick,
  // stage
  // mIjX6CA152HvYKmKNGvvxffbq2OzfRxp: BRANDS.blick,
  bca5be3255d8df13e0550916a9b36ca0: BRANDS.blick,
  // prod
  // GuDzFnvdGnh1gAaB4lcXX42J0YxsaLHL: BRANDS.blick,
  bb8b3e76968088ece03d9c30a05cedc8: BRANDS.blick,

  // Blick Web
  // dev
  u8IACmeHfJx9UWZlnUoUmFHy9MRVBTUG: BRANDS.blick,
  // stage
  // QiQsPyS8NNexn6BGbIdfVAyGaihbDsrP: BRANDS.blick,
  '0a41bc5ff18efc3851032dfe24c1408f': BRANDS.blick,
  // prod
  // iq6JnMWfrXwdLWQxNSPzlCChFaMI2O9B: BRANDS.blick,
  '6d8dcfe7824c089600ba85267a6f5ec4': BRANDS.blick,

  // Blick Invitation flow
  // dev
  // stage
  '7e4f65aec9e1f6dd85478db263bf33ab': BRANDS.blick,
  // prod
  '0ce64014f408fc170f1cb0d9d77a0017': BRANDS.blick,

  // Profile
  // dev
  T1NCDHcwlp9nbiqAE4DZzJHlUVqd1Rvr: BRANDS.blick,
  // stage
  cpd2G4hAZNr2cuDT6WWrj1gk4ztrRbSg: BRANDS.blick,
  // prod
  '5vGUhG9Ezn4cu5Qt2ZXAYoZ82UDDVpWn': BRANDS.blick,

  // Energy
  // dev
  k5aG4M1VCe16wu1qFGaPe7lqt23PYysk: BRANDS.energy,
  // stage
  // oAWZakeaP56R8wJIEpEKIkjuPWAbEMnz: BRANDS.energy,
  // cc096f52e552fc3bc90d9cd89e4cf09b: BRANDS.energy,
  // '9da3c0e63e09db3fba88236c59ea6ba9': BRANDS.energy,
  '771634f140ba7c8f144c248f4f4a7417': BRANDS.energy, // web
  '139eb14fb42b3f6f454d19f3bdc937a6': BRANDS.energy,
  // prod
  // JWT9GBjMcaJ7dn8FCzZ7SVESpgYj98nq: BRANDS.energy,
  // a0a64d126a1dfe7de260ca6ea5648149: BRANDS.energy,
  // fe5b374f3b924faeb4e13699938c78d7: BRANDS.energy,
  f19435886ae1797a15d0fdc17dcc6b6a: BRANDS.energy, // web
  c9ea6c1b806e119c5018cd3dee4b01dd: BRANDS.energy, // native

  // Beobachter
  // dev
  KWljlSzbgIC0u2x6jTfVZFPFeG3nTXQ1: BRANDS.beobachter, // native
  // stage
  U3LIrxgEqO4MmENm841ckx9Psrede2DH: BRANDS.beobachter, // native
  // '22eeb724e4aa095c6745427af099809a': BRANDS.beobachter, // web
  '5e6f0dd338934b283ea3588dbf902d35': BRANDS.beobachter, // web
  // '2881a4ec76023cd7f797a6ed25061462': BRANDS.beobachter, // invitation
  e65a339f5d42bc3eb44b96d8629224fa: BRANDS.beobachter, // invitation
  // prod
  ALFutKy9Jpdlre0FLhCx5a4zd3Ko6Au4: BRANDS.beobachter, // native
  // '0db6a6dfaa2f43b3b2dec3bfc559fa68': BRANDS.beobachter, // web
  // '9e986d620489a4ade3ded818f384282c': BRANDS.beobachter, // invitation
  '8ab7a1bbe02c0dd8ec62b40ab57fc2f7': BRANDS.beobachter, // web
  '144ad83c64a2672abd5ba79f6c825c42': BRANDS.beobachter, // invitation

  // WIME
  // dev
  Krg9em3ifSUkwsAT4iQ0OAnKmD5JGCBM: BRANDS.wirtschaftsmedien, // native
  // stage
  v1g9SBq0gODHcZHAb075yRt5CK7e4MMy: BRANDS.wirtschaftsmedien, // native
  // '8f1cdf98498a067a2afbfae42ec9a882': BRANDS.wirtschaftsmedien, // web
  b08dac916d575ce0b7328c9f210fa3cd: BRANDS.wirtschaftsmedien, // web
  // prod
  PfD5ANcJ4rfRxbfSyw4LUumfSJgS2TVu: BRANDS.wirtschaftsmedien, // native
  // '2760bd06705742ee8c9a66fed1f122ec': BRANDS.wirtschaftsmedien, // web
  '06d811a7d7de3927c19f2cfabd362900': BRANDS.wirtschaftsmedien, // web

  // Schweizer Illustrierte
  // dev
  Z2uuDDOlSLUBBq2K7yfVGavR5D5n3V5b: BRANDS.schweizerillustrierte, // native
  // stage
  g2ktFcBXjMxMEiRs1V5hP5Jv2tYI2ZG9: BRANDS.schweizerillustrierte, // native
  // ddf295ba1c4e91819abb2b51121bf108: BRANDS.schweizerillustrierte, // web
  '44a7fb4af34f792a3733dcbae5437f02': BRANDS.schweizerillustrierte, // web
  // prod
  // HbJvGoqmxtd5gHekAul7gbPIiV8oJ5UC: BRANDS.schweizerillustrierte, // native
  // daa11a2617ad4f28ae24a8dc62a454ce: BRANDS.schweizerillustrierte, // web
  '02359a4a6a1f1dedce936e4ea55f1230': BRANDS.schweizerillustrierte, // web

  // Moon and Stars
  // dev
  '10abeb0f5f564454bdbb035ea252bcd9': BRANDS.moonandstars,
  // stage
  // '44375c6d5325453d82a9b6ae6f4419f9': BRANDS.moonandstars,
  // '928371f50b9cb2551c5873451f33caba': BRANDS.moonandstars,
  '846627c0580d9e932834600d762366d3': BRANDS.moonandstars, // web
  // prod
  // '586884bbc46847ecbf54a22206cf47c4': BRANDS.moonandstars,
  // c992f057c4e760fafe3ae3f0de5f8cdb: BRANDS.moonandstars,
  aff258ebb512f976e9baafd11a2ac7eb: BRANDS.moonandstars,

  // Vintage Radio
  // dev
  '41ce1c7b5aef4f10a919dcb469d7147d': BRANDS.vintage,
  // stage
  // '9bb2ba3934234b93b93bb2fc9d98c590': BRANDS.vintage,
  '930b7f3dc73b7efcb7788218e6905135': BRANDS.vintage, // web
  '4184322643a01ac9e4a3b634401479e2': BRANDS.vintage, // native
  // prod
  // a087b5fe8e0542e69d87ee88c5dcb0f1: BRANDS.vintage,
  '16d91603cf569cc6c5beaa0070d1523f': BRANDS.vintage, // web
  '543c0ecdae06fbf8cb1c43d7aa0935c6': BRANDS.vintage, // native

  // Schlager Radio
  // dev
  '3217ef0b08d44064a744c7290aeffb7c': BRANDS.schlager,
  // stage
  // bbcd84df042f4a9fb573e97549390780: BRANDS.schlager,
  fcc0f1fc162b47b88c75900f39d88ce5: BRANDS.schlager, // web
  '6b372db0c938fe05b8848e042a991688': BRANDS.schlager, // native
  // prod
  // '6cf466a3923945d68d4296470e75cecf': BRANDS.schlager,
  '7fc5cfe2757256b19be025ce981d8f39': BRANDS.schlager, // web
  ea617dc4de4eab7a7e528ec69088cb61: BRANDS.schlager, // native

  // Rockit
  // dev
  '927cdde47ec44a2886a6b62a0fa7722f': BRANDS.rockit, // web
  // stage
  // f079540cc46a443f934c2ea92e637fba: BRANDS.rockit, // web
  '138db04bdcc9b5132dd1af816ddac55c': BRANDS.rockit, // web
  a3ee026a157707e87a759872bdacd4d4: BRANDS.rockit, // native
  // prod
  // '10432f66684d40f3b13c65e35d7997f8': BRANDS.rockit, // web
  '544b1eba052bd8c429e1655cc7ba7d2c': BRANDS.rockit, // web
  '0cb60328150ef1b74140fb5c9cb02985': BRANDS.rockit, // native

  // Testing Brand
  // dev
  IftqiKbpzK7mljcr2l0BSYj8fw0CmbCx: BRANDS.testing, // web
  '54be4411ffda35fcfdc0612879464895': BRANDS.testing, // web

  // PME
  // dev
  '69342b34d1e2ad30abfd8cac65e317d4': BRANDS.pme, // native
  // stage
  // '44a7a0d44c3201fe514b351c27bd06e3': BRANDS.pme, // web
  '5066ef4a0fe2b0f25ee3afacd1db0d52': BRANDS.pme, // web
  // prod
  // '551faa4c61865c2e3e9db5077c08788b': BRANDS.pme, // web
  '3e4cce2b66a769eaff45fc63dd9ef3af': BRANDS.pme, // web

  // Illustre
  // dev
  '28abf9acd473fb600c29c7a8f5be6940': BRANDS.illustre, // web
  // stage
  // '96f1e4511935ab7e3eda42e8b63dcce9': BRANDS.illustre, // web
  '8964195f56dd1345a560702ca539e262': BRANDS.illustre, // web
  // prod
  // '5845ce667e78c34fd4ee724b95fb4834': BRANDS.illustre, // web
  '1fa66346ef33bc33618bbe51ad1e4992': BRANDS.illustre, // web

  // SRG
  '72fac81a7f692ad0e73955b5bc683b46': BRANDS.srg, // web
  // '5dde8144d78ecbf3085bcdb0cdc2e1b8': BRANDS.srg, // stg web
  dd06e60362cdf4b72c60e5ca7dfdbe59: BRANDS.srg, // stg web
  // e2f252ff07203e4b0c992734de9b48eb: BRANDS.srg, // prod web
  '055d752b976848006d91c94bdd565d91': BRANDS.srg, // prod web

  // lessentiel
  '59179c00f25dc6eb00623315e8d080b0': BRANDS.lessentiel, // web
  // '63d18137defc7e576d5b81a10548d32c': BRANDS.lessentiel, // web
  '1ff3ec1a01ae69184433cc8694b10bed': BRANDS.lessentiel, // web
  // prod
  // '4809b195aa9d12efbe46ec1a722fe2b5': BRANDS.lessentiel, // web
  b2cb291babbe5adae8314717e1d11afc: BRANDS.lessentiel, // web

  // cash
  // dev
  a36b748c4897b57495563f0343954f47: BRANDS.cash, // web

  // stg
  d1c1f83b0353a0c19ffff39e2c4e3180: BRANDS.cash, // web

  // prod
  // c07a14a66268a1af6428b7c50c17bd67: BRANDS.cash, // web
  '33ead33a1b2dd3cffeeb532ca36c5453': BRANDS.cash, // web

  // Interview by Ringier
  '0c93e5af42476f837777894736c558db': BRANDS.interview, // web
  // '023ecdfa42ae3ad13e7b30242ce7a5fd': BRANDS.interview, // web
  '54ce92d682ae9bb5b790d4bc6c00fddd': BRANDS.interview, // web
  // prod
  // '44f944fc4eac9cc133293d7260f0b6bb': BRANDS.interview, // web
  '82b964631e7aa4667dba55ed0c9f3e2a': BRANDS.interview, // web

  // jobs
  // dev
  '2a632db5b331ee65764a0813c058e441': BRANDS.jobs, // web
  // stg
  // c79b67414c94db2f88f805fcf50b8d0b: BRANDS.jobs, // web
  '6d15f2934aeb1858694b4c281e0f15ee': BRANDS.jobs, // web
  f771502620c3542d8ed658fabab76b5a: BRANDS.jobs, // invitation
  // prod
  // '937572930ad0d66ba59031893b6be0a5': BRANDS.jobs, // web
  '7c8842484d5de80e9620fa808c9737d0': BRANDS.jobs, // web
  b5fbe713c3069d63a08931a5d4c07a3f: BRANDS.jobs, // invitation

  // jobup
  // dev
  b05b6aa1d2e34ae7b8d03035d6c18a77: BRANDS.jobup, // web
  // stg
  // a2988719b2976ebb796bbe8455e35221: BRANDS.jobup, // web
  '0dcc5d8ca116982f28bdb1dedbbe81fa': BRANDS.jobup, // web
  '22afd44b6dc4cbf97c43689ddfecedbf': BRANDS.jobup, // invitation
  // prod
  // '0c6eeb09f92b792c4ab273d461d00033': BRANDS.jobup, // web
  c4ae2648c83a7e30c537b80ab8ac8f6d: BRANDS.jobup, // web
  '6bf3b531a19b910a358d0f47a751a5fe': BRANDS.jobup, // invitation

  // jobscout24
  dbde0217454783fa16a6b0ab6299df12: BRANDS.jobscout24, // web
  '571b3486ad31a2cd4615fc485dcf97d0': BRANDS.jobscout24, // web
  '2719bc61786ef6e44fd2abc60f44f603': BRANDS.jobscout24, // web

  // redsport
  '0a288772bbbdf8873c9c4710f396dc20': BRANDS.redsport, // dev web
  '79d0ad67dff62154b81cd25ac4dbbb4a': BRANDS.redsport, // stg web
  ac501ad80b422b4824d9851189e2946d: BRANDS.redsport, // stage native
  '4a2f57a074147694672faaa08b9c2b9e': BRANDS.redsport, // prod web
  '4f44dae2f3205b63e2c6fdf8d8342b4b': BRANDS.redsport, // prod native

  // caminada
  d762a9a95d5aa3184baaafb91be84e13: BRANDS.caminada, // dev web
  // e87027e6dbf89be9ed5d20180d47a014: BRANDS.caminada, // stage web
  '5d73273b7860bac6a35c0d5df5d77ff7': BRANDS.caminada, // stage web
  // dfade7addebd5ac14b14c27a2f975572: BRANDS.caminada, // prod web
  '159c4c56beaaa9125b1527a053c5f516': BRANDS.caminada, // prod web
  // glueckspost
  '46157626c2faf78e1a4e8bcc748e0b70': BRANDS.glueckspost, // dev web
  // '79cb2e3a15285a0cdae95857445c162e': BRANDS.glueckspost, // stage web
  e05cd5c0057917d371d1a50204379f50: BRANDS.glueckspost, // stage web
  // f5d973a9aec8726d17ecc79634a26ead: BRANDS.glueckspost, // prod web
  '03f0984f8d4523885ae3c803e792426a': BRANDS.glueckspost, // prod web
  // programmzeitschriften
  '236434ebeafb9e86c71318853be04599': BRANDS.programmzeitschriften, // dev web
  // d8dc6867f2a9628e65fe02b169415a50: BRANDS.programmzeitschriften, // stage web
  fddf3fb9cbdfe27a29d3b750c8381dbc: BRANDS.programmzeitschriften, // stage web
  '320eed07a53892c6cfa75ac59f2ed6af': BRANDS.programmzeitschriften, // prod web
  ebe329b80d46913836249483b97cdab6: BRANDS.programmzeitschriften, // prod web
  // landliebe
  '8f6f33b45a2747f75a9ea2472acd5b41': BRANDS.landliebe, // dev web
  // '12c7df1599d30916064a46977fa41198': BRANDS.landliebe, // stage web
  '16ad03078e12cbbff9157782b981bf66': BRANDS.landliebe, // stage web1
  // f1ca4af6f6753dcfba98dde97145b164: BRANDS.landliebe, // prod web
  f5c5b82e89a96e9b9fb92d61681eb75c: BRANDS.landliebe, // prod web
  // zff
  '942bd752b4374e4173b91ade2679189c': BRANDS.zff, // dev web
  // '82763c6353f1e2c45f6b2b4f653468fb': BRANDS.zff, // stage web
  '05e64cf3c8997f2c29daf3f5e68e6f89': BRANDS.zff, // stage web
  // bfb4ab7199750d2ece16e75b3da36088: BRANDS.zff, // prod web
  a3960b0ac939ba9341d791c1321972fa: BRANDS.zff, // prod web
  // aargauerzeitung
  '50947d981a1cebb8bf53cd61534a07a4': BRANDS.aargauerzeitung, // dev web
  // '3c18f8ab386885eb12dd3b7c167e44e2': BRANDS.aargauerzeitung, // stage web
  b3af58355b75110ca7544fa67b723fbc: BRANDS.aargauerzeitung, // stage web
  // '4dcf2ddd3c7994d9b6034d1359d554a8': BRANDS.aargauerzeitung, // prod web
  '8af253cbac6000a4e8c97793a84c19a9': BRANDS.aargauerzeitung, // prod web
  // ticketcorner
  f1290ddba24b17694ca1a486699fbc48: BRANDS.ticketcorner, // dev web
  d223b1d579ed06e1405abca158cd9ce9: BRANDS.ticketcorner, // stage web
  '41e9926d509760247bf3264a849e703d': BRANDS.ticketcorner, // prod web
  // jobbern
  '63e3ddbaa9252655900be4f5e45dad3c': BRANDS.jobbern, // dev web
  // f56e20390817f732701120fec0d84ca3: BRANDS.jobbern, // stage web
  '501c92d8ec2d800c4e72326cb4adbd99': BRANDS.jobbern, // stage web
  '1229205c49a2e3ba8a1a117c5a974822': BRANDS.jobbern, // stage invitation
  // '4c88caf749abf92040decdf8cac1f116': BRANDS.jobbern, // prod web
  '4c88caf749abf92040decdf8cac1f116': BRANDS.jobbern, // prod web
  '9908ceb304278367776ee02fdd104b83': BRANDS.jobbern, // prod invitation
  // autodesjahres
  '36151374f85001aedb47e51a6fd9a14f': BRANDS.autodesjahres, // dev web
  // '9b5cca74a5529ee1d41acde7c1478496': BRANDS.autodesjahres, // stage web
  '2886db410a8c721857a533a1b4de40cc': BRANDS.autodesjahres, // stage web
  // '91c1888367c0ba92cfab2b7a4b87dd08': BRANDS.autodesjahres, // prod web
  bfd9ff0fed5f1c91cfb2a6fc9c2b0162: BRANDS.autodesjahres, // prod web
  // nzz
  '2aaa97f18c7978be64a3fad0e128ea33': BRANDS.nzz, // dev web
  // d65e4f666e134384fccd3807db117938: BRANDS.nzz, // stage web
  f247468c5cfb86e25bd9eefbf27abb27: BRANDS.nzz, // stg web
  '401c9f3939a3836fbb1d3f1996821281': BRANDS.nzz, // stg invitation
  // '57258093d521bdeeb1e58f92ec1179d5': BRANDS.nzz, // prod web
  '40a935a6d12f75987a48a9dba964acdb': BRANDS.nzz, // prod web
  b038f7f427340dd6f19c618346f77cc8: BRANDS.nzz, // prod invitation
  // watson
  cd300ec72349841a272d1d942f6b4a27: BRANDS.watson, // dev web
  // d5964d8fde387a0d4cede0f4400f49c9: BRANDS.watson, // stage web
  '2f4aaf3fdcd8b24074e100ed1821d30d': BRANDS.watson, // stage web
  // bc7730be0eef3db50b7e0e79b3b9226f: BRANDS.watson, // prod web
  '5e5516c937171f162c857eb4a9c4adab': BRANDS.watson, // prod web
  // OneLog
  // dev
  afe8041c7ec177e1a924af070408b06a: BRANDS.onelog, // web
  // stage
  d777942369238f8f2358af9b2e0aa749: BRANDS.onelog, // democlient
  '1faef48d1301ac9b0a7e7a7e81c96151': BRANDS.onelog, // profile
  pclHy3PpsA9duP4eYPO5J6A2EcgTAz1J: BRANDS.onelog, // admin
  // prod
  ED7awjuIiNPQ7YkWBZ8k7Btx82OUrBs4: BRANDS.onelog, // democlient
  FsKcjkxTKHd6SH3Yi7KrISsiM50bz4Ec: BRANDS.onelog, // profile
  zS6IYzmyIsJZ60WAJryoQqmitDnUMdoO: BRANDS.onelog, // admin
}

const CLIENT_MAP = {
  ...TX_GROUP_CLIENT_MAP,
  ...ONELOG_CLIENT_MAP,
  ...BRANDS,

  // for compatibility with some backend redirects that use brand parameter instead of client
  '20min': BRANDS.twentymin,
  '24hours': BRANDS.twentyfourhours,
}

export const getClient = (windowObject = window) => {
  if (!windowObject) {
    return BRANDS.onelog
  }
  const params = qs.parse(windowObject.location.search.slice(1))
  return CLIENT_MAP[params.brand || params.client || params.client_id] || BRANDS.onelog
}

export const isMobileClient = (windowObject = window) => {
  const webview = getWebview(windowObject.location.search)
  const hashWebview = getWebview(windowObject.location.hash.replace(/[/|#]/g, ''))

  return (webview && webview === 'true') || (hashWebview && hashWebview === 'true')
}

export const isBlickMobileClient = (windowObject = window) => {
  if (!windowObject) {
    return BRANDS.onelog
  }
  const params = qs.parse(windowObject.location.search.slice(1))
  const clientId = params.client || params.client_id
  return BLICK_MOBILE_CLIENT_IDS.includes(clientId)
}

const getThemeOverride = (windowObject = window) => {
  if (!windowObject) {
    return null
  }
  const params = qs.parse(windowObject.location.search.slice(1))
  return CLIENT_THEME[params.brand_theme]
}

export const getTheme = (windowObject = window) =>
  getThemeOverride(windowObject) || CLIENT_THEME[getClient(windowObject)] || CLIENT_THEME[BRANDS.onelog]

export const getConfigValue = (configName, options = {}) => {
  const theme = getTheme()
  const config = theme.config[configName]
  return typeof config === 'function' ? config(options) : config
}

export const getFooterLogo = (lang = 'de') => {
  const validLang = LANDING_PAGE_LANGUAGES.includes(lang) ? lang : 'de'
  return `${config.url}/assets/brands/onelog/logos/black-${validLang}.png`
}
